import { render, staticRenderFns } from "./CreateEducationModal.vue?vue&type=template&id=4789fbad&"
import script from "./CreateEducationModal.vue?vue&type=script&lang=js&"
export * from "./CreateEducationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports